import {
    createSlice
}
    from '@reduxjs/toolkit';

const initialState = {
    sortByText: "Modified Date",
    sortBy: 1,
    ascending: false,
    open: false,
    sortItems: [
        {
            text: "Modified Date",
            value: 1
        },
        {
            text: "Created Date",
            value: 2
        }
    ]
};

export const jobSorterSlice = createSlice({
    name: 'jobSorter',
    initialState,
    reducers: {
        updateAscending: (state, action) => {
            state.ascending = action.payload;
        },
        toggleMenu: (state, action) => {
            state.open = action.payload;
        },
        toggleAscending: (state, action) => {
            state.ascending = action.payload;
        },
        setSortItem: (state, action) => {
            const { sortByText, sortBy, open } = action.payload;
            state.sortByText = sortByText;
            state.sortBy = sortBy;
            state.open = open;
        },
        hideMenu: state => {
            state.open = false;
        }
    }
});

export const { updateAscending, setSortItem, toggleMenu, toggleAscending, hideMenu } = jobSorterSlice.actions;

export default jobSorterSlice.reducer

export const selectJobSorterDetail = state => {
    return {
        sortByText: state.jobSorter.sortByText,
        sortBy: state.jobSorter.sortBy,
        ascending: state.jobSorter.ascending,
        open: state.jobSorter.open,
        sortByItems: state.jobSorter.sortItems
    }
}

export const selectSort = state => {
    return {
        by: state.jobSorter.sortBy,
        ascending: state.jobSorter.ascending
    }
};
